module.exports = __webpack_public_path__ + "img/path.b0362886.png";